import { Routes, Route, Navigate } from "react-router-dom";
import { useAuth } from "@/context/AuthContext";
import AdminLogin from "@/admin/AdminLogin";
import AdminLayout from "@/admin/AdminLayout";

export default function AdminApp() {
  const { user } = useAuth();

  if (user === null) return <div className="min-h-screen bg-ink" />;

  return (
    <Routes>
      <Route path="/admin/login" element={
        user && user.role === "admin" ? <Navigate to="/admin" replace /> : <AdminLogin />
      } />
      <Route path="/admin/*" element={
        user && user.role === "admin" ? <AdminLayout /> : <Navigate to="/admin/login" replace />
      } />
    </Routes>
  );
}
